// This file stores keyboard key codes that are used with the keydown DOM event
export const LETTER_F = 70
export const LETTER_O = 79
export const LETTER_R = 82
export const LETTER_S = 83
